import React from 'react'
import { localisationMaster } from 'Localisation/Localisation'
import styles from './WeekDays.module.scss'
import useWindowWidth from '../../../../CRM/utils/hooks/useWindowWidth'

const weekDays = [
  { id: 1, text: localisationMaster('day-1', 'online-schedule/time-slots') },
  { id: 2, text: localisationMaster('day-2', 'online-schedule/time-slots') },
  { id: 3, text: localisationMaster('day-3', 'online-schedule/time-slots') },
  { id: 4, text: localisationMaster('day-4', 'online-schedule/time-slots') },
  { id: 5, text: localisationMaster('day-5', 'online-schedule/time-slots') },
  { id: 6, text: localisationMaster('day-6', 'online-schedule/time-slots') },
  { id: 7, text: localisationMaster('day-7', 'online-schedule/time-slots') },
]

const mWeekDays = [
  { id: 8, text: localisationMaster('mDay-1', 'online-schedule/time-slots') },
  { id: 9, text: localisationMaster('mDay-2', 'online-schedule/time-slots') },
  { id: 10, text: localisationMaster('mDay-3', 'online-schedule/time-slots') },
  { id: 11, text: localisationMaster('mDay-4', 'online-schedule/time-slots') },
  { id: 12, text: localisationMaster('mDay-5', 'online-schedule/time-slots') },
  { id: 13, text: localisationMaster('mDay-6', 'online-schedule/time-slots') },
  { id: 14, text: localisationMaster('mDay-7', 'online-schedule/time-slots') },
]

function WeekDays() {
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth <= 768
  const currentWeekDays = isMobile ? mWeekDays : weekDays
  return (
    <ul className={styles.weekdays}>
      {currentWeekDays.map(({ id, text }) => (
        <li key={id.toString()} className={styles.weekday}>
          {text}
        </li>
      ))}
    </ul>
  )
}

export default WeekDays
